import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const CheckSquare: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M630 630H150V150h405c41.36 0 75 33.64 75 75zm-450-30h420V225c0-24.81-20.19-45-45-45H180z' />
    <path d='M375.23 504.62C376.16 503.51 515 280 515 280c-14.05-8.78-32.56-4.51-41.34 9.54L361.3 469.31l-63.66-73.24c-12.5 10.87-13.83 29.82-2.96 42.32l31.86 36.65-.22-.05 26.14 29.88c2.97 3.39 7.12 5.12 11.29 5.12 3.51 0 7.03-1.22 9.87-3.71.48-.42 1.61-1.66 1.61-1.66z' />
  </IconBase>
));

CheckSquare.displayName = 'CheckSquare';

export default CheckSquare;
